<template>
    <div class="kf-content kf-content-list">
        <div class="kf-content-navs ">
            <div class="kf-content-nav ">
                <div class="kf-content-nav-icon2 hvr-grow  nac-back-hover" @click="goBack"><i class="iconfont icon-xiangzuo"></i></div>
                <div class="kf-content-box ml5">
                    <div class="kf-content-box-title3" style="margin-top: 3%">{{currMenu.name}}</div>
                </div>
                <div class="kf-content-box ml5">
                    <div class="kf-content-box-title3" style="margin-top: 18%">  <div class="kf-content-box-title2-icon2"></div></div>
                </div>
            </div>
            <div class="kf-content-search">
                <el-input v-model="search"  clearable @change="doSearch"
                          @clear="clear">
                    <template #append><i class="iconfont icon-search" @click="doSearch"></i></template>
                </el-input>
            </div>
        </div>
        <div class="kf-contents">
            <div class="kf-contents-box2 kingfisher_scroll">
               <div class="kf-list-con hvr-grow"
                    v-for="(item, index) in projectList"
                    :key="index"
                    @click="selectedList(item)">
                   <div class="kf-list-con-img">
                       <div class="kf-contents-con-img-modal"></div>
                       <img class="kf-list-img"
                            :src="getImageUrl(item.uuid)"
                       />
                   </div>
                   <div class="kf-list-con-txt"> <i class="iconfont icon-add-bold ml10 mr3" style="font-size: 12px"></i>{{item.name}}</div>
               </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {computed, onMounted, ref, watch} from 'vue'
  import menuModel from '@/model/menu'
  import projectService from '@/service/project'
  export default {
    name: "content-list",
    setup(){
      let search=ref("");
      let projectList=ref([]);
      let projects=ref([]);
      let host=ref("");
      let url = window.location.href;
      host.value = url.substring(0, url.indexOf("/#/")) + "/portal/";
      const goBack=function () {
        search.value="";
        menuModel.updateCurrMenu({});
      }

      onMounted(() =>{
        loadProjectList();
      })
      const loadProjectList=function () {
        if(menuModel.currMenu.value.type && menuModel.currMenu.value.type!=''){
          projectService.getAll(menuModel.currMenu.value.type).then(result =>{
            projectList.value=result;
            projects.value=result;
          });
        }

      }
      const selectedList=function (item) {
        menuModel.updateCurrProject(item)
      }
      
      const getImageUrl=function (id) {
        return host.value + 'api/repo/kf-project/get-image?projectId='  + id;
      }
      watch(() => menuModel.currMenu.value, (newValue, oldValue) => {
        if (newValue !== oldValue) {
          loadProjectList();
        }
      })


      const clear = function () {
        projectList.value = projects.value;
      };
      const doSearch = function (val) {
        let result = [];
        if (projects.value && projects.value.length > 0) {
          if (search.value == '') {
            result = projects.value;
          }
          else {
            projects.value.forEach(item => {
              if (item.name.indexOf(search.value) != -1) {
                result.push(item);
              }
            })
          }
        }
        projectList.value = result;
      };
      
      return {
        currMenu:menuModel.currMenu,
        search,
        goBack,
        selectedList,
        projectList,
        getImageUrl,
        doSearch,
        clear
      }
    }
  }
</script>

<style scoped>

</style>